import { pinInputSlotRecipe } from "./recipes/pin-input";
import { buttonRecipe } from "./recipes/button";
import { inputRecipe } from "./recipes/input";
import { textareaRecipe } from "./recipes/textarea";

export const recipes = {
  pinInput: pinInputSlotRecipe,
  button: buttonRecipe,
  input: inputRecipe,
  textarea: textareaRecipe
}